'use strict';

/**
 * @ngdoc service
 * @name vTvPackageServices.TvPackageCartStoreInterface
 * @description defines an interface that is used to create instances of storage types
 */

angular.module('v-tv-package-services').factory('TvPackageCartStoreInterface', function TvPackageCartStoreInterface($log) {
  //disabling no-unused-vars rules because we are only defining an interface.
  /* eslint-disable no-unused-vars */

  /**
   * @ngdoc service
   * @name vTvPackageServices.TvPackageCartStore
   * @param {string} storeTypeName a name to help identify the storage type
   * @description defines an interface that is used to create instances of storage types
   * @returns {TvPackageCartStore} TvPackageCartStore
   */
  return function TvPackageCartStore(storeTypeName) {

    /**
     * @property {string} storeTypeName a name to help identify the storage type
     */
    this.storeTypeName = storeTypeName;

    /**
     * @property {boolean} canWrite true if this store is identified as writable, otherwise read only
     */
    this.canWrite = false;

    /**
     * @ngdoc method
     * @name vTvPackageServices.TvPackageCartStore#getItem
     * @methodOf vTvPackageServices.TvPackageCartStore
     * @param {string} key identifies the data to retrieve
     * @returns {*} the value associated with the key
     */
    this.getItem = function (key) {
      throw Error('getItem must be implemented');
    };

    /**
     * @ngdoc method
     * @name vTvPackageServices.TvPackageCartStore#getValueToWrite
     * @methodOf vTvPackageServices.TvPackageCartStore
     * @param {string} key identifies the data to retrieve
     * @param {*} value the data that would be stored
     * @returns {*} the data that is formatted in the way the storage would handle it
     */
    this.getValueToWrite = function (key, value) {
      $log.error('this instance does not expose this function.');
    };

    /**
     * @ngdoc method
     * @name vTvPackageServices.TvPackageCartStore#setItem
     * @methodOf vTvPackageServices.TvPackageCartStore
     * @param {string} key identifies the data to retrieve
     * @param {*} value the stored value
     */

    this.setItem = function (key, value) {
      throw Error('setItem must be implemented');
    };
    /* eslint-enable no-unused-vars */
    Object.seal(this);
  };
});